export default "__VITE_PUBLIC_ASSET__9de6c5e6__"